module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-47.11a0baaa.png";